import { useTranslation } from 'react-i18next';
import { ModalLayout } from './ModalLayout';

interface DeleteConfirmModalProps {
  isOpen: boolean;
  onClose: () => void;
  onConfirm: () => void;
}

export const DeleteConfirmModal = ({ isOpen, onClose, onConfirm }: DeleteConfirmModalProps) => {
  const { t } = useTranslation();

  return (
    <ModalLayout
      isOpen={isOpen}
      onClose={onClose}
      title={t('products.deleteConfirm.title')}
    >
      <p className="text-gray-600 mb-6">
        {t('products.deleteConfirm.message')}
      </p>
      <div className="flex justify-end gap-3">
        <button className="btn btn-ghost" onClick={onClose}>
          {t('common.cancel')}
        </button>
        <button className="btn btn-error" onClick={onConfirm}>
          {t('products.deleteConfirm.confirm')}
        </button>
      </div>
    </ModalLayout>
  );
}; 